import { UAParser } from "ua-parser-js";

export function getChannelSource() {
    const parser = new UAParser();
    const result = parser.getResult();

    let deviceModel = result.device.model;
    const osName = result.os.name;

    if (osName === "Windows" && !deviceModel) {
        deviceModel = "pc";
    }

    const fingerprint = {
        device: deviceModel,
        device_vendor: result.device.vendor,
        os: osName,
        os_version: result.os.version,
        browser: result.browser.name,
        browser_version: result.browser.version
    };

    return {
        "X-FedaPay-Device-Fingerprint": btoa(JSON.stringify(fingerprint)),
        "X-FedaPay-Referrer": document.referrer
    };
}
